/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import Colors from 'constants/Colors';
import { Text, FontWeight } from 'components/Text';

const Content = styled.div`
  background: ${Colors.WHITE};
  margin-top: 40px;
  border: 1px solid ${Colors.BLUE};
  background: #fff;
  margin-bottom: 40px;
  border-radius: 20px;
  box-shadow: 0px 17px 17px 6px #5f5f5f1a;
  padding: 30px;
`;

const Heading = styled.div`
  background: ${Colors.BLUE};
  color: ${Colors.WHITE};
  padding: 17px 25px;
  font-weight: ${FontWeight.SemiBold};
  text-transform: uppercase;
  font-size: 15px;
  border-radius: 15px 15px 0px 0px;
  margin: -30px -30px 0px -30px;
`;


const TitleChart = styled(Text)`
  font-size: 16px;
  display: block;
  margin-top: 30px;
  margin-left: 10px
`;

const TitleCalendar = styled(Text)`
  font-size: 16px;
  display: block;
  margin-top: 30px;
  margin-left: 10px
  margin-bottom: 20px;
`;

const Legend = styled.div`
  height: 60px;

  .content{
    p{
      width: 50%;
      display: inline-block;
      font-size: 13px;
      color: #777;
    }
    p:first-child{
      text-align: right;
    }
    span{
      width: 10px;
      height: 10px;
      margin-right: 5px;
      display: inline-block;
      margin-left: 10px;
    }
  }
`;


export { Content, Heading, TitleChart, TitleCalendar, Legend };
